import { render, staticRenderFns } from "./GlobalStyles.vue?vue&type=template&id=96fb6b28&"
import script from "./GlobalStyles.vue?vue&type=script&lang=js&"
export * from "./GlobalStyles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports